// A custom theme for this app
import { createTheme } from '@mui/material';

const theme = createTheme({
  cssVariables: true,
  // colorSchemes: { light: true, dark: true },
  components: {
    MuiAlert: {
      styleOverrides: {
        filledWarning: {
          color: '#fff',
        },
      },
    },
  },
  palette: {
    warning: {
      light: '#ffb300',
      main: '#eb9d00',
      dark: '#c28200',
      contrastText: '#fff',
    },
  },
  typography: {
    h2: { fontWeight: 500 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    subtitle1: { fontWeight: 700 },
    subtitle2: { fontWeight: 700 },
    allVariants: {
      fontFamily: "'Twemoji', 'Exo 2', sans-serif",
    },
  },
});

export default theme;
